import { useMediaQuery } from '@uhg-abyss/web/hooks/useMediaQuery';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { useTranslation } from 'react-i18next';

import { StoreKeys } from '../../hooks/useStore/state';
import { useStore } from '../../hooks/useStore/useStore';
import { shouldUseGehaV2Styling } from '../../utils/gehaThemeUtils';
import { phoneOnly } from '../ConstantsStyles';
import { ProviderIndicator } from './DetailsPageHeader.styled';

export type Props = {
  virtualCareOffered: boolean;
  iconColor?: string;
  textColor?: string;
};

export const VirtualCareOfferedLabel = ({
  virtualCareOffered,
  iconColor = '$core.color.brand.100',
  textColor = '$core.color.neutral.90',
}: Props) => {
  const { t } = useTranslation();
  const isWidget = useStore(StoreKeys.IS_WIDGET);
  const mobileScreen = useMediaQuery(phoneOnly) || isWidget;

  if (!virtualCareOffered) return null;

  const isGEHAV2 = shouldUseGehaV2Styling();

  textColor = isGEHAV2 ? '$core.color.brand.100' : textColor;

  return (
    <Layout.Group space={0}>
      <IconSymbol
        color={iconColor}
        data-auto-testid="videocam-icon"
        icon="videocam"
        size={mobileScreen ? '20px' : '$md'}
        variant="filled"
      />
      <ProviderIndicator
        color={mobileScreen ? iconColor : textColor}
        fontSize={mobileScreen ? 'md' : 'lg'}
        fontWeight={mobileScreen ? 'regular' : 'medium'}
      >
        {t('DETAILS_PAGE.OFFERS_VIRTUAL_CARE')}
        {virtualCareOffered}
      </ProviderIndicator>
    </Layout.Group>
  );
};
